import v2 from '../v2Client';

const MANUALS_PATH = '/operations-manuals';

const FETCH_MANUALS_ERROR_MESSAGE = 'Operations manuals could not be loaded';

const manualPath = (manualKey) => `${MANUALS_PATH}/${encodeURIComponent(manualKey)}`;

const state = {
  manuals: [],
  isLoaded: false,
};

const getters = {
  pendingManuals: (state) => state.manuals.filter(
    (manual) => manual.current_version && !manual.current_version.is_acknowledged,
  ),
  firstManualKey: (state) => (state.manuals[0] ? state.manuals[0].key : null),
  hasManuals: (state) => state.manuals.length > 0,
};

const mutations = {
  SET_MANUALS(state, manuals) {
    state.manuals = manuals;
    state.isLoaded = true;
  },
  SET_ACKNOWLEDGED(state, { manualKey, versionId }) {
    const manual = state.manuals.find((candidate) => candidate.key === manualKey);
    if (manual && manual.current_version && manual.current_version.id === versionId) {
      manual.current_version.is_acknowledged = true;
    }
  },
};

const actions = {
  async fetchManuals({ commit }) {
    try {
      const { data } = await v2.get(MANUALS_PATH);
      commit('SET_MANUALS', data.data);
    } catch (error) {
      console.error(FETCH_MANUALS_ERROR_MESSAGE, error);
    }
  },
  async fetchHome(context, manualKey) {
    const { data } = await v2.get(manualPath(manualKey));
    return data.data;
  },
  async fetchChapter(context, { manualKey, chapterSlug }) {
    const { data } = await v2.get(`${manualPath(manualKey)}/chapters/${encodeURIComponent(chapterSlug)}`);
    return data.data;
  },
  async fetchVersions(context, manualKey) {
    const { data } = await v2.get(`${manualPath(manualKey)}/versions`);
    return data.data;
  },
  async search(context, { manualKey, query }) {
    const { data } = await v2.get(`${manualPath(manualKey)}/search`, { params: { q: query } });
    return data.data;
  },
  async fetchPdfUrl(context, { manualKey, versionId }) {
    const params = versionId ? { version: versionId } : {};
    const { data } = await v2.get(`${manualPath(manualKey)}/pdf`, { params });
    return data.data.url;
  },
  async acknowledge({ commit }, { manualKey, versionId }) {
    await v2.post(`${manualPath(manualKey)}/versions/${versionId}/acknowledge`);
    commit('SET_ACKNOWLEDGED', { manualKey, versionId });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
